<template>
  <div>
    <section-header heading="2" ja="撮影したプリクラやモーメントをダウンロードするには？"/>
    <div class="textArea">
      <p>
        ■セガのプリクラ機でメールアドレスを入力して受け取る<br>
        撮影後に、らくがきブースでメールアドレスを入力すると、プレイ終了後に「データダウンロード用メール」が送られてきます。<br>
        メール内に記載のURLにアクセスし、「プリクラON」の会員登録を行うことで、プリクラデータを受け取ることができます。<br>
        ※「entry@puri.jp」からのメールを受け取れるように、あらかじめ受信設定を確認してください。<br>
        ※プリ機によってはメールアドレス入力が無い場合があります
      </p>
      <p>
        ■セガのプリクラ機でプリクラON会員証を認証して受け取る<br>
        撮影前に、あらかじめ「プリクラON」の会員登録を行い、セガのプリクラ機の受付でQR会員証をかざしておくと、プレイ終了後にプリクラデータを自動で受け取ることができます。
      </p>
      <p>
        ■シールIDを入力して受け取る<br>
        プレイ終了後に、印刷されるプリントシールに記載の「シールID(15桁)」を入力することで、プリクラデータを受け取ることができます。<br>
        ※ダウンロードするには、「プリクラON」への会員登録が必要です。<br>
        ※「プリクラON」内にある「プリダウンロード」のページでシールIDを入力します。
      </p>
      <p>
        ■QRコードを読み取って受け取る<br>
        ・らくがきブースの「メールアドレス入力画面」上に表示されているQRコード<br>
        ・印刷されたシールに印字されているQRコード<br>
        上記のいずれかをQRコードリーダー等で読み取ると、専用ダウンロードページにアクセスでき、「プリクラON」のログインまたは会員登録を行うことで、プリクラデータを受け取ることができます。<br>
        また、アプリ内の「シールのQRを読み込む」からQRコードを読み込むことで、ダウンロードすることも可能です。<br>
        ※お使いのQRコードリーダーによっては、QRコードを読み取りにくい場合があります。<br>
        読み取りにくい場合は、シールIDを入力することでプリクラデータを受け取ることができます。<br>
        ※プリ機によってはメールアドレス入力が無い場合があります
      </p>
    </div>
    <section-header heading="2" ja="すべてのダウンロード方法を試したけどできない時は？"/>
    <div class="textArea">
      <p>以下の場合、撮影したプリクラを閲覧・ダウンロードができません。</p>
      <p>
        ■シールIDの入力間違い<br>
        シールIDは数字15桁です。<br>
        シールに書かれているシールID(数字15桁)を再度ご確認ください。
      </p>
      <p>
        ■店舗のネットワーク環境<br>
        プレイ時の店舗のネットワーク環境によっては、
        <ul>
          <li>・データダウンロード用のメールが送られない</li>
          <li>・シールIDを入力しても閲覧できない</li>
        </ul>
        という状況が起きる場合があります。時間を置いて再度お試しください。<br>
        それでも改善されない場合は、プリクラON内の「お問い合わせ」からご連絡ください。
      </p>
      <p>
        ■プリクラのダウンロード期限<br>
        撮影したプリクラのダウンロード期限は、撮影日から1週間となります。<br>
        ※期限を過ぎてシールIDの入力などを行っても閲覧できません。
      </p>
    </div>
    <section-header heading="2" ja="いらなくなったプリをアルバムから消したい"/>
    <div class="textArea">
      <p>
        アプリ版のアルバムからプリクラを表示して、削除アイコンを押してください。<br>
        アルバムからプリを削除したあとに同じプリを再びダウンロードすることは出来ませんのでご注意ください。
      </p>
    </div>
    <section-header heading="2" ja="間違ってアルバムから削除したプリを元に戻したいときは、どうすればいい？"/>
    <div class="textArea">
      <p>削除したプリは元に戻すことができませんのでご注意ください。</p>
    </div>
    <section-header heading="2" ja="自分のプリではないデータが届いた"/>
    <div class="textArea">
      <p>
        身に覚えのないプリデータが届いた場合、別の方がお客様と同じアドレスを入力して送信された可能性があります。<br>
        保存せずに以下ご対応をお願いいたします。
      </p>
      <ul>
        <li>・通知メールの削除</li>
        <li>・プリデータを保存してしまった場合は当該データの削除</li>
      </ul>
      <p>お客様が「プリクラON」の会員様の場合で、ご自身が撮影されたデータ以外が連続して届く場合は、お手数お掛けいたしますが「プリクラON」にご登録のメールアドレスの変更をお願いいたします。</p>
    </div>
    <sub-btn @click="onAboutWeb()">プリクラONについてに戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
  ul {
    margin:1em 0;
    padding-left: 0;
    li {
      list-style-type: none;
      display: block;
    }
  }
}
</style>
